class SignatariosDocumentoAnexosUrlBuilder {
	constructor(tipo) {
		this.PATH = tipo.path
	}

	getUrlBuscarSignatariosDocumentoAnexos(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/signatarios/buscar`
	}

	getUrlConvidarSignatariosDocumentoAnexos(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/signatarios/convidar`
	}

	getUrlExcluirSignatariosDocumentoAnexos(idDocumento) {
		return `api/${this.PATH}/documentos/${idDocumento}/signatarios/excluir`
	}
}

export default SignatariosDocumentoAnexosUrlBuilder
